export interface EnvironmentConfigs {
  env: string;
  firebase: { apiKey: string; authDomain: string };
  defaultRedirectURI: string;
  requireConsent: boolean;
  unityOrigin?: string;
  apigee: {
    url: string;
    sessionInfoPath: string;
    instancesListPath: string;
    consentPath: string;
    resetPasswordPath: string;
    clientId: string;
  };
  newCustomerInit: {
    url: string;
    instanceListPath: string;
  };
  /** Apigee developer that owns the dynamically registered (AI connector) OAuth clients. */
  dcrDeveloperEmail: string;
  oxs: { termsUrl: string };
}

declare global {
  interface Window {
    __CONFIG__: EnvironmentConfigs;
  }
}

export function getEnvironmentConfigs() {
  return window.__CONFIG__ as EnvironmentConfigs;
}
